import { HierarchyManager } from "../../components/HierarchyManager";
import { regionCountriesConfig } from "./regionCountriesConfig";

/**
 * Read-only "WordPress Regions" page. Renders the hierarchical
 * `api_region_country_v2` taxonomy (region → countries) using the shared
 * `HierarchyManager` tree in read-only mode, mirroring the `/taxonomy/regions`
 * admin page but without any create/edit/delete affordances.
 */
function RegionCountriesPage() {
  return <HierarchyManager config={regionCountriesConfig} />;
}

export default RegionCountriesPage;
